import styled from 'styled-components'

export const TanksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
`

export const TankCard = styled.div`
  background: ${({ theme }) => theme.colorSurface1};
  border: 1px solid ${({ theme }) => theme.colorDividerDefault};
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  gap: 1rem;
  align-items: stretch;
`

export const TankVisual = styled.div`
  position: relative;
  width: 45px;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colorSurfaceBase};
  border-radius: 12px;
  overflow: hidden;
  min-height: 140px;
`

export const TankFill = styled.div<{ h: number; color: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${(p) => p.h}%;
  background: ${(p) => p.color};
  border-radius: 0 0 12px 12px;
  transition: height 0.4s ease;
`

export const PctBadge = styled.div<{ color: string; h: number }>`
  position: absolute;
  bottom: ${(p) => (p.h > 0 ? `max(12px, ${p.h / 2}%)` : '0')};
  left: 50%;
  transform: translate(-50%, ${(p) => (p.h > 0 ? '50%' : '0')});
  background: ${(p) => (p.h > 0 ? p.color : 'transparent')};
  color: #fff;
  font-size: 0.875rem;
  font-weight: 700;
  border-radius: 8px;
  padding: 2px 6px;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  z-index: 1;
  transition: bottom 0.4s ease;
`

export const TankInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
`

export const TankTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`

export const TankName = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.textColor};
`

export const StatusPill = styled.span<{ tone: 'ok' | 'watch' | 'low' }>`
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid
    ${({ tone }) => (tone === 'ok' ? '#22C55E' : tone === 'watch' ? '#F97316' : '#EF4444')};
  color: ${({ tone }) => (tone === 'ok' ? '#22C55E' : tone === 'watch' ? '#F97316' : '#EF4444')};
`

export const TankMetricLabel = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.textFaded};
  margin-bottom: 2px;
`

export const TankMetricValue = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.textColor};
`

export const TankMetricRow = styled.div`
  display: flex;
  gap: 1.5rem;
`

export const TankMetricBlock = styled.div``
